<template>
	<div class="progress m-d-8">
		<div class="progress-bar"
		     :class="{
			'green': green,
			'blue': blue,
			'yellow': yellow,
		     }"
		     role="progressbar"
		     :style="{ width: percent +'%' }"
		     :aria-valuenow="percent"
		     aria-valuemin="0"
		     aria-valuemax="100"
		></div>
	</div>
</template>

<script>
export default {
	name: "SOProgressBar",
	props: {
		percent: Float32Array,
		green: Boolean,
		blue: Boolean,
		yellow: Boolean,
	}
}
</script>